enum Status {
  IDLE = "idle",
  LOADING = "loading",
  FAILED = "failed",
}

enum ModalType {
  NONE = "NONE",
  LOGIN = "LOGIN",
  SIGN_UP = "SIGN_UP",
  LEAVE = "LEAVE",
  APP_DOWNLOAD = "APP_DOWNLOAD",
  TERMS = "TERMS",
  REVIEW_WRITE = "REVIEW_WRITE",
  REVIEW_EDIT = "REVIEW_EDIT",
  REVIEW_DETAIL = "REVIEW_DETAIL",
  EVENT_REGISTERER = "EVENT_REGISTERER",
  AFFILIATE_CODE = "AFFILIATE_CODE",
  EXTERNAL_VOUCHER = "EXTERNAL_VOUCHER"
}

interface SliceState {
  status: Status;
}

interface ModalContent {
  title: string;
  desc: string;
  callback?: () => void;
}

interface ConfirmModalContent {
  content: ModalContent;
  confirmFunc: VoidFunction;
}

export interface ChildrenProp {
  children: JSX.Element;
}

enum StyleRequestType{
  MEMBER= "MEMBER",
  SIGN_UP= "SIGN_UP"
}

enum UnitVoucherType{
  KPASS = "KPASS",
  DCAS = "DCAS",
  COUNSELOR = "COUNSELOR",
}

enum UserType{
  USER = "USER",
  ORGAN_MANAGER = "ORGAN_MANAGER",
  CONSULTANT_MANAGER = "CONSULTANT_MANAGER",
  CONSULTANT = "CONSULTANT",
}

enum MemberType {
  PERSONAL = "PERSONAL",
  GROUP = "GROUP"
}

interface RenderStrategy {
  execute(): JSX.Element;
}

export type { SliceState, ModalContent, ConfirmModalContent, RenderStrategy };
export { Status, ModalType, StyleRequestType, UnitVoucherType, UserType , MemberType};
